import { Entity } from "@models/Entity";
import { productErrorMapper } from "src/features/products/errors";
import { customerErrorMapper } from "src/features/customers/errors";
import { locationErrorMapper } from "src/features/locations/errors";
import { orderErrorMapper } from "src/features/orders/errors";
import { billingErrorMapper } from "src/features/billing/errors";
import { imageErrorMapper } from "src/shared/errors/imageErrors";
import type { FeatureErrorMapper } from "./types";

export const featureErrorMappers: Partial<
  Record<Entity, FeatureErrorMapper>
> = {
  [Entity.PRODUCTS]: productErrorMapper,
  [Entity.CUSTOMERS]: customerErrorMapper,
  [Entity.LOCATIONS]: locationErrorMapper,
  [Entity.ORDERS]: orderErrorMapper,
  [Entity.BILLING]: billingErrorMapper,
  [Entity.IMAGES]: imageErrorMapper,
};
